import {
  Text,
  Box,
  Button,
  Alert,
  AlertIcon,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Flex,
  Select,
  Stack,
  Checkbox,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";

export default function SelectedDates() {
  const [values, setValues] = useState(
    JSON.parse(window.sessionStorage.getItem("filterDate"))
  );

  const [offDates, setOffDates] = useState([]);

  const [multipleDateMessage, setMultipleDateMessage] = useState(false);
  const [cutOffTimeMessage, setCutOffTimeMessage] = useState(false);
  const [cutOffTimeMessageError, setCutOffTimeMessageError] = useState(false);
  const [multipleDateMessageError, setMultipleDateMessageError] =
    useState(false);
  const [weekendCheckbox, setWeekendCheckbox] = useState(
    JSON.parse(window.sessionStorage.getItem("filterWeekend")) || {
      sunday: false,
      saturday: false,
    }
  );
  const [endMonthDays, setEndMonthDays] = useState(
    JSON.parse(window.sessionStorage.getItem("endMonthDisable")) || ""
  );
  const [cutOffTime, setCutOffTime] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const selectedDates = values?.map((date) =>
    date.toLocaleString("en-GB", { timeZone: "UTC" })
  );

  const fetchOffDates = async () => {
    const url = `${process.env.REACT_APP_RALCO_API_URL}/api/settings/off-dates`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();

    if (data) {
      setOffDates(data.value.split(","));
    } else {
      setOffDates([]);
    }
  };

  const fetchCutOffTime = async () => {
    const url = `${process.env.REACT_APP_RALCO_API_URL}/api/settings/delivery-cutoff-time`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    
    const data = await response.json();

    if (data) {
      setCutOffTime(data.value);
    } else {
      setCutOffTime(null);
    }
  };

  

  //   save handler
  const saveHandler = async () => {
    console.log(selectedDates);
    if (!selectedDates || selectedDates.length === 0) {
      setMultipleDateMessageError(true);
      setTimeout(() => {
        setMultipleDateMessageError(false);
      }, 2500);
      return;
    }
    
    const url = `${process.env.REACT_APP_RALCO_API_URL}/api/settings/off-dates`;
    const body = selectedDates;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200) {
      setMultipleDateMessage(true);
      setTimeout(() => {
        setMultipleDateMessage(false);
      }, 2500);
    } else {
      setMultipleDateMessageError(true);
      setTimeout(() => {
        setMultipleDateMessageError(false);
      }, 2500);
    }
  };

  const saveCutOffTime = async () => {
    const url = `${process.env.REACT_APP_RALCO_API_URL}/api/settings/delivery-cutoff-time`;
    const body = [cutOffTime];

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (response.status === 200) {
      setCutOffTimeMessage(true);
      setTimeout(() => {
        setCutOffTimeMessage(false);
      }, 2500);
    } else {
      setCutOffTimeMessageError(true);
      setTimeout(() => {
        setCutOffTimeMessageError(false);
      }, 2500);
    }
  }

  //   weekend selected days
  useEffect(() => {
    window.sessionStorage.setItem(
      "filterWeekend",
      JSON.stringify(weekendCheckbox)
    );
    window.sessionStorage.setItem(
      "endMonthDisable",
      JSON.stringify(endMonthDays)
    );
    fetchOffDates();
    fetchCutOffTime();
  }, [weekendCheckbox, endMonthDays]);
  console.log("offDates", offDates);
  console.log("values", values);
  console.log('cutOffTime', cutOffTime);

  return (
    <>
      <Flex justifyContent={"space-between"} mt={2}>
        {/* Select Multiple disabled date */}
        <Box flexBasis={"30%"}>
          <Text
            fontSize={"18px"}
            fontWeight={"semibold"}
            letterSpacing={"wide"}
            mb={"2px"}
          >
            Select off Dates
          </Text>
          <DatePicker
            style={{
              width: "154%",
              padding: "16px 8px 16px 8px",
              fontSize: "16px",
              border: "1px solid",
              borderColor: "inherit",
              borderRadius: "6px",
            }}
            className="selected-date"
            multiple
            value={offDates}
            format="YYYY-MM-DD"
            onChange={setValues}
            minDate={new Date()}
            onClick={(e) => {
              setMultipleDateMessageError(false);
              e.stopPropagation();
            }}
            placeholder="Select Multiple Dates"
            plugins={[<DatePanel />]}
          />
          {multipleDateMessage && (
            <Alert
              status="success"
              py={1}
              mt={1}
              w={"100%"}
              rounded={"md"}
              fontSize={"13px"}
              letterSpacing={"wider"}
            >
              <AlertIcon />
              Selected date successfully updated!
            </Alert>
          )}
          {multipleDateMessageError && (
            <Alert
              status="error"
              py={1}
              mt={1}
              w={"70%"}
              rounded={"md"}
              fontSize={"13px"}
              letterSpacing={"wider"}
            >
              <AlertIcon />
              Please select date
            </Alert>
          )}
          <Box mt={2}>
            <Button
              isDisabled={multipleDateMessage}
              bgColor={"white"}
              mr={3}
              size={"xs"}
              px={6}
              shadow={"md"}
              rounded={"sm"}
              onClick={(e) => {
                e.stopPropagation();
                onOpen();
                setValues([]);
              }}
            >
              Cancel
            </Button>
            <Button
              colorScheme="twitter"
              size={"xs"}
              px={6}
              shadow={"md"}
              rounded={"sm"}
              onClick={saveHandler}
            >
              Save
            </Button>
            {window.sessionStorage.getItem("filterDate") && (
              <AlertDialog
                motionPreset="slideInBottom"
                onClose={onClose}
                isOpen={isOpen}
                isCentered
              >
                <AlertDialogOverlay>
                  <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                      Delete selected dates
                    </AlertDialogHeader>

                    <AlertDialogBody>
                      Are you sure? You can't undo this action afterwards.
                    </AlertDialogBody>

                    <AlertDialogFooter>
                      <Button onClick={onClose}>Cancel</Button>
                      <Button
                        colorScheme="red"
                        onClick={(e) => {
                          window.sessionStorage.removeItem("filterDate");
                          e.stopPropagation();
                          setValues([]);
                          onClose();
                        }}
                        ml={3}
                      >
                        Delete
                      </Button>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialogOverlay>
              </AlertDialog>
            )}
          </Box>
        </Box>
        {/* select end month date for disable */}
        <Box flexBasis={"30%"}>
          <Text fontSize={"18px"} fontWeight={"semibold"} mb={"2px"}>
            Select Month End off Days
          </Text>
          <Select
            placeholder="Select Days"
            bgColor={"white"}
            value={endMonthDays}
            height={"34px"}
            onChange={(e) => setEndMonthDays(e.target.value)}
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
          </Select>
        </Box>
        {/* Weekend Disabled */}
        <Box flexBasis={"30%"}>
          <Text fontSize={"18px"} fontWeight={"semibold"} mb={"2px"}>
            Weekend off Day
          </Text>
          <Stack spacing={5} direction="row">
            <Checkbox
              disabled
              colorScheme="twitter"
              isChecked={weekendCheckbox.saturday}
              onChange={(e) =>
                setWeekendCheckbox({
                  ...weekendCheckbox,
                  saturday: e.target.checked,
                })
              }
            >
              Saturday
            </Checkbox>
            <Checkbox
              disabled
              colorScheme="twitter"
              isChecked={weekendCheckbox.sunday}
              onChange={(e) =>
                setWeekendCheckbox({
                  ...weekendCheckbox,
                  sunday: e.target.checked,
                })
              }
            >
              Sunday
            </Checkbox>
          </Stack>
        </Box>
      </Flex>
      <Flex justifyContent={"space-between"} mt={10}>
        <Box flexBasis={"30%"}>
          <Text fontSize={"18px"} fontWeight={"semibold"} mb={"2px"}>
            Delivery cut-off time
          </Text>
          <Select
            placeholder="Select Time"
            bgColor={"white"}
            value={cutOffTime}
            height={"34px"}
            onChange={(e) => setCutOffTime(e.target.value)}
          >
            {Array.from({ length: 24 }, (_, i) => (
              <option key={i} value={i}>
                {i} hour
              </option>
            ))}
          </Select>
          
          {
            cutOffTimeMessage &&
          
            <Alert
              status="success"
              py={1}
              mt={1}
              w={"100%"}
              rounded={"md"}
              fontSize={"13px"}
              letterSpacing={"wider"}
            >
              <AlertIcon />
              Cut-off time successfully updated!
            </Alert>
          
          
        }

        {

          cutOffTimeMessageError &&
        
            <Alert
              status="error"
              py={1}
              mt={1}
              w={"70%"}
              rounded={"md"}
              fontSize={"13px"}
              letterSpacing={"wider"}
            >
              <AlertIcon />
              Please select time
            </Alert>
          }
          <Button
            colorScheme="twitter"
            size={"xs"}
            px={6}
            mt={4}
            shadow={"md"}
            rounded={"sm"}
            onClick={saveCutOffTime}
          >
            Save
          </Button>
        </Box>
      </Flex>
    </>
  );
}
